import { useSnackbar } from 'notistack';
import { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { UserService } from 'api';
import { useMSAL } from 'auth/msalProvider';
import userState from 'state/user';
const LOGOUT_TIMEOUT_MS = 10000;
const useHandleUser = () => {
  const {
    account,
    logout
  } = useMSAL();
  const [user, setUser] = useRecoilState(userState);
  const {
    t
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const handleErrors = useCallback(error => {
    const status = error.response?.status;
    if (status === 400) {
      enqueueSnackbar({
        type: 'warning',
        message: t('error.error_getting_user_ref')
      });
    }
    if (status === 500 || status === 502) {
      enqueueSnackbar({
        type: 'error',
        message: t('error.server_error')
      });
      setTimeout(() => {
        logout();
      }, LOGOUT_TIMEOUT_MS);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [t]);
  const registerUser = useCallback(async () => {
    try {
      const response = await UserService.registerUser({
        body: {
          displayName: account?.username || account?.name
        }
      });
      if (response) setUser(response);
    } catch (e) {
      handleErrors(e);
    }
  }, [account?.name, account?.username, handleErrors, setUser]);
  const fetchUser = useCallback(async () => {
    try {
      const response = await UserService.getUserByAccessToken();
      if (response) setUser(response);
    } catch (e) {
      console.error(e);
      if (e.response.status === 404) registerUser();else handleErrors(e);
    }
  }, [handleErrors, registerUser, setUser]);
  useEffect(() => {
    if (account && !user?.displayName) fetchUser();
  }, [account, fetchUser, user?.displayName]);
  return user;
};
export default useHandleUser;